// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AcademyParallaxUi$LiteracyplanetClientSxEntry from "./AcademyParallaxUi.res.mjs";
import * as AcademyParallaxData$LiteracyplanetClientSxEntry from "./AcademyParallaxData.res.mjs";

function AcademyIndexContainer(props) {
  return React.createElement(AcademyParallaxData$LiteracyplanetClientSxEntry.Provider.make, {
              onPlayActivity: props.onPlayActivity,
              md5: props.md5,
              returnFromActivityId: props.returnFromActivityId,
              children: React.createElement(AcademyParallaxUi$LiteracyplanetClientSxEntry.make, {
                    onBack: props.onBack
                  })
            });
}

var make = AcademyIndexContainer;

export {
  make ,
}
/* react Not a pure module */
